import { render, staticRenderFns } from "./cCenterCoste.vue?vue&type=template&id=352324a2&"
import script from "./cCenterCoste.vue?vue&type=script&lang=js&"
export * from "./cCenterCoste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports